import { doc, getDoc } from "firebase/firestore";
import { useEffect, useState } from "react";
import db from "../modules/firebaseMod.js";

import "../scss/Letter.scss"
import postcard from "../imgs/postcard.png"

const abs = Math.abs
// const floor = Math.floor

const LogoImages = ""

function Letter()
{
    const [letter, setLetter] =  useState({})
    const [rot, setRot] = useState(0)
    const [clicked, setClicked] = useState(false)

    useEffect(() => {
        const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
          });


        const docRef = doc(db, "letters", params.letter);
        const docPromise = getDoc(docRef);

        docPromise.then((docSnap) => {
            if (docSnap.exists()) 
            {
                console.log(docSnap.data())
                setLetter(docSnap.data())
            }
            
        })

        
    }, [])

    function inView()
    {
        return (abs(rot - Math.round(rot/4)*4))  < 1 || clicked
    }

    function onslide()
    {
        setRot((document.getElementById("letterSlider").value - 50)/50 * 0.5)
    }

    return <div className="letter-container">
        <div className="letterSliderContainer">
            <input type="range" min="1" max="100" onInput ={onslide} className="letterSlider" id="letterSlider"/>
        </div>
        <div className="hint-label">Click to Zoooooom</div>
        <div className="letter" id='letter' onClick={() => {setClicked(!clicked)}}
        style={{
            transform: clicked? "":`rotateX(15deg) rotateY(${-rot*90}deg)`,
            scale: clicked?"1.5":"1"
            }}>
            
            <div className="letter-frost"></div>
                <div className="letter-name">{letter.name}</div>
                <div className="letter-description">{letter.description}</div>
                <div className="info"></div>
                <div className="logo-tag"></div>
                {/* <div className="stamp">
            	<div src="../imgs/link-letter-logo.png" />
                </div> */}
                <div className="logos-container">
                    {letter.handles&&Object.keys(letter.handles).map((site) => {
                        return <a key={site} href={letter.handles[site]} className="sight-logo" style={{
                        backgroundImage: `url("/icons/${site}.png")`
                        }}></a>
                })}
            </div>
      
        </div>
    </div>
}

export default Letter
